import { forwardRef, useEffect, useId, useState } from "react";
import { InputProps } from "./Input";
import React from "react";
import { InputLayout } from "./Input.styles";
import styled from "styled-components";
import { ClipIcon } from "assets/icons";

const FileInput = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      errorMessage,
      type,
      placeholder,
      id: customId,
      file,
      className,
      style,
      value,
      ...args
    },
    ref,
  ) => {
    const id = useId();

    const [fileName, setFileName] = useState<string | undefined>(
      file?.name || "",
    );

    useEffect(() => {
      if (file) {
        setFileName(file.name);
      }
    }, [file]);

    return (
      <FileInputLayout
        isError={!!errorMessage}
        isFileUploaded={!!fileName}
        className={className}
        style={style}
      >
        <input
          id={customId ?? id}
          type="file"
          ref={ref}
          style={{
            display: "none",
          }}
          {...args}
        />
        <label htmlFor={customId ?? id} className="file-label">
          <ClipIcon />
          {fileName || placeholder}
        </label>
        <label>{errorMessage}</label>
      </FileInputLayout>
    );
  },
);

FileInput.displayName = "FileInput";

export default FileInput;

const FileInputLayout = styled(InputLayout)<{
  isFileUploaded: boolean;
}>`
  .file-label {
    display: flex;
    align-items: center;
    gap: 0.8rem;

    padding: 1.2rem 1.4rem;
    border: 1px solid ${({ theme }) => theme.color.stroke.light};
    border-radius: 0.5rem;
    ${({ theme }) => theme.typography.body1.regular};
    color: ${({ theme, isFileUploaded }) =>
      isFileUploaded ? theme.color.text.default : theme.color.text.placeholder};
    cursor: pointer;

    :hover {
      background-color: ${({ theme }) => theme.color.grey[100]};
      border: 1px solid ${({ theme }) => theme.color.stroke.dark};
    }

    svg {
      flex-shrink: 0;
      color: ${({ theme }) => theme.color.icon.tertiary};
    }
  }
`;
